import React, { useEffect, useState } from 'react';
import { Box, Checkbox, HStack, Stack, Text, VStack } from '@chakra-ui/react';
import Select from 'react-select';
import { ProgramInfo } from '../../../generated/graphqlModels';

interface ProgramInfoProps {
  setFilteredProgramInfos: (programInfos: ProgramInfo[]) => void;
  programInfos: ProgramInfo[];
}

const ProgramFilter = (props: ProgramInfoProps) => {
  const { setFilteredProgramInfos, programInfos } = props;
  const [selectedProgramRanks, setSelectedProgramRanks] = useState<string[]>(
    [],
  );
  const [selectedTechnicalSkills, setSelectedtechnicalSkills] = useState<
    string[]
  >([]);
  const [selectedProfessionalCompetences, setSelectedProfessionalCompetences] =
    useState<string[]>([]);
  const [selectedTechFields, setSelectedTechFields] = useState<string[]>([]);
  const programRanks = programInfos.reduce((acc, cur) => {
    cur.programRank
      .split(',')
      .map((a) => a.trim())
      .forEach((programRank) => {
        if (!acc.includes(programRank) && programRank.length > 0) {
          acc.push(programRank);
        }
      });
    return acc;
  }, [] as string[]);
  const technicalSkills = programInfos.reduce((acc, cur) => {
    cur.technicalSkills
      .split(',')
      .map((a) => a.trim())
      .forEach((tag) => {
        if (!acc.includes(tag) && tag.length > 0) {
          acc.push(tag);
        }
      });
    return acc;
  }, [] as string[]);
  const professionalCompetences = programInfos.reduce((acc, cur) => {
    cur.professionalCompetences
      .split(',')
      .map((a) => a.trim())
      .forEach((tag) => {
        if (!acc.includes(tag) && tag.length > 0) {
          acc.push(tag);
        }
      });
    return acc;
  }, [] as string[]);
  const techFields = programInfos.reduce((acc, cur) => {
    cur.techFields
      .split(',')
      .map((a) => a.trim())
      .forEach((tag) => {
        if (!acc.includes(tag) && tag.length > 0) {
          acc.push(tag);
        }
      });
    return acc;
  }, [] as string[]);

  useEffect(() => {
    const filterValues = [
      ...selectedProfessionalCompetences,
      ...selectedProgramRanks,
      ...selectedTechnicalSkills,
      ...selectedTechFields,
    ];
    if (filterValues.length === 0) {
      setFilteredProgramInfos([...programInfos]);
    } else {
      setFilteredProgramInfos(
        programInfos.filter((programInfo) => {
          const programCompetences = programInfo.professionalCompetences
            .split(',')
            .map((a) => a.trim());
          const programRanks = programInfo.programRank
            .split(',')
            .map((a) => a.trim());
          const programSkills = programInfo.technicalSkills
            .split(',')
            .map((a) => a.trim());
          const techFields = programInfo.techFields
            .split(',')
            .map((a) => a.trim());

          return (
            (selectedProgramRanks.length === 0 ||
              selectedProgramRanks.some((rank) =>
                programRanks.includes(rank),
              )) &&
            selectedTechnicalSkills.every((skill) =>
              programSkills.includes(skill),
            ) &&
            selectedProfessionalCompetences.every((pc) =>
              programCompetences.includes(pc),
            ) &&
            selectedTechFields.every((field) => techFields.includes(field))
          );
        }),
      );
    }
  }, [
    selectedProgramRanks,
    selectedProfessionalCompetences,
    selectedTechnicalSkills,
    selectedTechFields,
  ]);

  return (
    <Stack
      color="black"
      alignItems={'center'}
      justifyContent="center"
      gap={4}
      spacing={0}
      direction={['column', 'column', 'column', 'row']}
      w="full"
      maxW="8xl"
    >
      <Box maxW="400px" w="full">
        <Select
          styles={{
            container: (provided, state) => ({
              ...provided,
              flex: 1,
            }),
          }}
          placeholder="Classes"
          options={programRanks.map((p) => ({ value: p, label: p }))}
          closeMenuOnSelect={false}
          isMulti
          isOptionSelected={(option) =>
            selectedProgramRanks.includes(option.value)
          }
          onChange={(values) => {
            if (values) {
              setSelectedProgramRanks(values.map((v) => v.value));
            } else {
              setSelectedProgramRanks([]);
            }
          }}
          select
        />
      </Box>
      <Box maxW="400px" w="full">
        <Select
          styles={{
            container: (provided, state) => ({
              ...provided,
              flex: 1,
            }),
          }}
          placeholder="Tech fields"
          options={techFields.map((p) => ({ value: p, label: p }))}
          closeMenuOnSelect={false}
          isMulti
          isOptionSelected={(option) =>
            selectedTechFields.includes(option.value)
          }
          onChange={(values) => {
            if (values) {
              setSelectedTechFields(values.map((v) => v.value));
            } else {
              setSelectedTechFields([]);
            }
          }}
          select
        />
      </Box>
      <Box maxW="400px" w="full">
        <Select
          styles={{
            container: (provided, state) => ({
              ...provided,
              flex: 1,
            }),
          }}
          placeholder="Technical skills"
          options={technicalSkills.map((p) => ({ value: p, label: p }))}
          closeMenuOnSelect={false}
          isMulti
          isOptionSelected={(option) =>
            selectedTechnicalSkills.includes(option.value)
          }
          onChange={(values) => {
            if (values) {
              setSelectedtechnicalSkills(values.map((v) => v.value));
            } else {
              setSelectedtechnicalSkills([]);
            }
          }}
          select
        />
      </Box>
      <Box maxW="400px" w="full">
        <Select
          styles={{
            container: (provided, state) => ({
              ...provided,
              flex: 1,
            }),
          }}
          placeholder="Professional Competences"
          options={professionalCompetences.map((p) => ({ value: p, label: p }))}
          closeMenuOnSelect={false}
          isMulti
          isOptionSelected={(option) =>
            selectedProfessionalCompetences.includes(option.value)
          }
          onChange={(values) => {
            if (values) {
              setSelectedProfessionalCompetences(values.map((v) => v.value));
            } else {
              setSelectedProfessionalCompetences([]);
            }
          }}
          select
        />
      </Box>
    </Stack>
  );
};

export default ProgramFilter;
